import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  personnel: null,
  status: "idle",
  error: null,
};

export const fetchPersonnel = createAsyncThunk(
  "personnel/fetchPersonnel",
  async (id) => {
    return await apiService(API_ROUTES.PERSONNEL, "GET", { replace: { id } });
  },
);

const personnelSlice = createSlice({
  name: "personnel",
  initialState,
  reducers: {
    resetPersonnel: (state) => {
      state.status = "idle";
      state.personnel = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPersonnel.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPersonnel.fulfilled, (state, action) => {
        action?.payload?.data.sort((a, b) => {
          if (a.name?.toLowerCase() || "" < b.name?.toLowerCase() || "") {
            return -1;
          }
          if (a.name?.toLowerCase() || "" > b.name?.toLowerCase() || "") {
            return 1;
          }
          return 0;
        });
        state.status = "succeeded";
        state.personnel = action.payload;
      })
      .addCase(fetchPersonnel.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const { resetPersonnel } = personnelSlice.actions;
export default personnelSlice.reducer;
